import React from 'react';
import { useTranslation } from 'react-i18next';

import Typography from 'components/Typography';
import { appReactMemo } from 'hocs';
import { useBreakpoint } from 'hooks/adaptive/useBreakpoint';
import { useAppDispatch, useAppSelector } from 'hooks/storeHooks';
import { useReportsModal } from 'modals';
import { setReportDownloadFlag } from 'store/userConfiguration';

import { Container, DownloadsIcon, IconWrapper } from './styled';
import { IReports } from './types';

interface IDownloadsProps {
  reports: IReports[];
}

const Downloads = ({ reports }: IDownloadsProps) => {
  const { t } = useTranslation('translation');
  const dispatch = useAppDispatch();
  const checkWindowWidth = useBreakpoint();

  const [showReports] = useReportsModal();

  const newReports = useAppSelector((state) => state.userConfiguration.isNewReport);

  const isNewReport = React.useMemo(() => {
    return !!reports?.filter((report) =>
      report.path ? newReports?.[report.path] || false : false,
    )?.length;
  }, [newReports, reports]);

  const onShowReports = React.useCallback(() => {
    showReports(reports);

    reports.forEach((report) => {
      if (report.path) {
        dispatch(setReportDownloadFlag({ [report.path]: false }));
      }
    });
  }, [dispatch, reports, showReports]);

  return (
    <Container data-testid='reportDownloads' onClick={onShowReports}>
      {checkWindowWidth(1000, 'min') && <Typography>{t('common.downloads')}</Typography>}
      <IconWrapper $displayDot={isNewReport}>
        <DownloadsIcon />
      </IconWrapper>
    </Container>
  );
};

export default appReactMemo(Downloads);
